import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { ProjectAvatarActions } from '@store/projectAvatar'
import { changeAvatar } from '@store/reducers/manager/meta/actionCreators'
import { updateProjectCustomAvatar } from '@storeOld/reducers/auth'
import {
  ErrorNotification,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { call, put, select } from 'redux-saga/effects'

import API from '@/api'
import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { parseError } from '../parseError'

interface UploadResponse {
  customAvatar: string
  customAvatarFilename: string
  errors?: {
    file: string
  }
}
interface UploadPayload {
  file: File | null
}

interface UploadData {
  projectId: string
  payload: UploadPayload
}

type UploadCb = (data: UploadData) => Promise<UploadResponse>

export function* upload({
  payload,
}: ReturnType<typeof ProjectAvatarActions.upload>) {
  const projectId: ID | null = yield select(
    migrationProjectSelector.getProjectId
  )

  if (!projectId || !payload || payload.length === 0) {
    return
  }

  const { customAvatar, customAvatarFilename, errors }: UploadResponse =
    yield call(API.Projects.uploadCustomAvatar as UploadCb, {
      projectId,
      payload: { file: payload[0] },
    })

  const message = parseError(errors)

  if (message) {
    yield put(ErrorNotification(message))
    return
  }

  yield put(
    updateProjectCustomAvatar({
      avatar: customAvatarFilename,
    })
  )

  yield put(notificationActionCreators.setClearAllNotification())

  sendGtmEvent(GtmTriggerName.PROJECT_UPLOAD_CUSTOM_LOGO)

  yield put(
    changeAvatar({
      customAvatar,
      customAvatarFilename,
      projectId,
    })
  )
}
